@let it = agreement();
<mat-toolbar>
  <h1>Agreement</h1>

  <span class="spacer"></span>
  <div class="cell-actions">
    <button matMiniFab (click)="location.back()" matTooltip="Go back">
      <mat-icon>reply</mat-icon>
    </button>

    <button matMiniFab matTooltip="Export Project Documentation" (click)="exportDocumentation()">
      <mat-icon>document_scanner</mat-icon>
    </button>

    <a matIconButton matTooltip="Open Knowledge Doc" target="_blank" [href]="kbLink">
      <mat-icon>menu_book</mat-icon>
    </a>
  </div>
</mat-toolbar>

@if (it) {
  <div class="grid">
    <section class="c-12 c-lg-8">
      <mat-toolbar>
        <h2>{{ it.AgreementNumber }}</h2>
        <span class="spacer"></span>
        <div class="cell-actions">
          @if (probablyHolded() && it.ServiceType !== 'AWS Hosting') {
            <button matTooltip="No recent Jira worklogs found in the last 3 months." matIconButton color="warn">
              <mat-icon>warning</mat-icon>
            </button>
          }
          @if (authService.isAdminOrEditor()) {
            <button matMiniFab (click)="edit()" [disabled]="pending()">
              <mat-icon>edit</mat-icon>
            </button>
          }
        </div>
      </mat-toolbar>
      <lcm-agreement-detail-table [agreement]="it"></lcm-agreement-detail-table>
    </section>

    <div class="c-12 c-lg-4">
      @if (it.Documents.length) {
        <div>
          <mat-toolbar>
            <h2>Documents</h2>
            <span class="spacer"></span>
          </mat-toolbar>
          <mat-list>
            @for (item of it.Documents; track item.DocumentId) {
              <mat-list-item>
                <span matListItemTitle [matTooltip]="item.DocumentName" matTooltipPosition="left">
                  {{ item.DocumentName }}
                </span>

                <button matListItemMeta matIconButton (click)="viewDocument(item.DocumentId)">
                  <mat-icon>open_in_new</mat-icon>
                </button>
              </mat-list-item>
            }
          </mat-list>
        </div>
      }

      <lcm-activity-stream [id]="'agreement' + +(it.AgreementNumber || 0)" />
    </div>

    <lcm-project-table class="c-12" [owner]="it" (updated)="reloadEntity()" />

    <lcm-extra-hours-table
      class="c-12"
      [pending]="pending()"
      property="UnchargeableHours"
      [owner]="it"
      [service]="itemService"
      (removed)="reloadEntity()"
      (added)="reloadEntity()"
    />

    <lcm-extra-hours-table
      class="c-12"
      [pending]="pending()"
      property="UnforeseenHours"
      [owner]="it"
      [service]="itemService"
      (removed)="reloadEntity()"
      (added)="reloadEntity()"
    />

    <lcm-extra-hours-table
      class="c-12"
      [pending]="pending()"
      property="ProfitableHours"
      [owner]="it"
      [service]="itemService"
      (removed)="reloadEntity()"
      (added)="reloadEntity()"
    />

    <lcm-addon-table
      class="c-12"
      [agreement]="it"
      (removed)="reloadEntity()"
      (added)="reloadEntity()"
      [pending]="pending()"
    />

    <div class="c-12">
      @if (isExpired() && it.Status === 'Expired') {
        @let date = it.EndDate | date: 'dd/MM/y';
        <div
          style="padding: 1rem; margin-bottom: 1rem"
          class="mat-bg-primary-container mat-text-on-primary-container mat-font-title-md"
        >
          Caution: This agreement has ended on
          <span class="mat-text-error">{{ date }}</span
          >. Therefore, no time logs more recent than
          <span class="mat-text-error">{{ date }}</span>
          are shown. If the agreement has been renewed, please update the End Date to see the most recent time reporting
          data.
        </div>
      }

      <lcm-time-reporting-widget [project]="it" />
    </div>
  </div>
} @else {
  <mat-spinner></mat-spinner>
}
